import { useTranslation } from '@mint-lib/i18n';
import { Illustration } from '@mint-lib/illustrations';
import { useRouter } from '@mint/routing';
import isMobile from 'is-mobile';

import { Box, Button, Icon, Typography } from '@myn/mui';

import { InternalServerErrorPageMobile } from './Mobile/InternalServerErrorPageMobile.jsx';

export const InternalServerErrorPage = () => {
  const { t } = useTranslation('@mint-lib/error-boundary');
  const router = useRouter();

  if (isMobile()) {
    return <InternalServerErrorPageMobile />;
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      gap={(theme) => theme.spacing(8)}
    >
      <Box
        display="inline-flex"
        flexDirection="column"
        justifyContent="center"
        gap={(theme) => theme.spacing(3)}
      >
        <Box
          display="inline-flex"
          gap={(theme) => theme.spacing(1)}
          alignItems={'center'}
        >
          <Icon
            component={'WarningFilled'}
            fontSize="large"
            className="fill-error-main text-error-main"
          />
          <Typography variant="h3" color={'error.main'}>
            {t('500 Internal Server Error')}
          </Typography>
        </Box>
        <Typography variant="h1" color="text.primary">
          {t('Something went wrong')}
        </Typography>
        <Typography variant="bodyShort01" color="text.primary">
          {t(
            'We are informed of your issue, we are working on it to resolve it.',
          )}
        </Typography>
        <Box display="flex" gap={2}>
          <Button
            onClick={() => {
              // Invalidate the route to reload the loader, and reset any router error boundaries
              router.invalidate();
            }}
            variant="outlined"
            size="large"
            color="primary"
          >
            {t('Reload the page')}
          </Button>

          <Button
            variant="contained"
            href="https://support.mint.ai"
            size="large"
            color="primary"
          >
            {t('Visit our Help Center')}
          </Button>
        </Box>
      </Box>
      <Illustration className="size-80" component="IllustrationError500" />
    </Box>
  );
};
